import { render, staticRenderFns } from "./person-intro.vue?vue&type=template&id=24cabbf6&scoped=true"
import script from "./person-intro.vue?vue&type=script&lang=js"
export * from "./person-intro.vue?vue&type=script&lang=js"
import style0 from "./person-intro.vue?vue&type=style&index=0&id=24cabbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cabbf6",
  null
  
)

export default component.exports